/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { Blockquote } from "@tiptap/extension-blockquote";
import { Bold } from "@tiptap/extension-bold";
import { BulletList } from "@tiptap/extension-bullet-list";
import { Code } from "@tiptap/extension-code";
import { CodeBlock } from "@tiptap/extension-code-block";
import { ColumnExtension } from "@gocapsule/column-extension";
// import { ColumnExtension } from './column-extension'
import { Document } from "@tiptap/extension-document";
import { Dropcursor } from "@tiptap/extension-dropcursor";
import { Gapcursor } from "@tiptap/extension-gapcursor";
import { HardBreak } from "@tiptap/extension-hard-break";
import { Heading } from "@tiptap/extension-heading";
import { History } from "@tiptap/extension-history";
import { HorizontalRule } from "@tiptap/extension-horizontal-rule";
import { Italic } from "@tiptap/extension-italic";
import { ListItem } from "@tiptap/extension-list-item";
import { OrderedList } from "@tiptap/extension-ordered-list";
import { Strike } from "@tiptap/extension-strike";
import { TableCell } from "@tiptap/extension-table-cell";
import { TableHeader } from "@tiptap/extension-table-header";
import { TableRow } from "@tiptap/extension-table-row";
import { TextAlign } from "@tiptap/extension-text-align";
import { Underline } from "@tiptap/extension-underline";
import { Text } from "@tiptap/extension-text";
import { TextStyle, Color as TextColor } from "@tiptap/extension-text-style";
import { SimpliCityTable } from "./simplicity-table/simplicity-table";
import { SimpliCityParagraph } from "./simplicity-paragraph/simplicity-paragraph";
import { SimpliCityLink } from "./simplicity-link/simplicity-link";
import { SimpliCityDocLink } from "./simplicity-doc-link/simplicity-doc-link";
// import Image from '@tiptap/extension-image'
import { SimpliCityImage } from "./simplicity-image/simplicity-image";

const tiptapExtensions = [
    Blockquote,
    Bold,
    BulletList,
    Code,
    CodeBlock,
    ColumnExtension,
    Document,
    Dropcursor,
    Gapcursor,
    HardBreak,
    Heading,
    History,
    HorizontalRule,
    Italic,
    ListItem,
    OrderedList,
    Strike,
    Text,
    TextAlign.configure({
        types: ["heading", "paragraph"],
        alignments: ["left", "center", "right"],
    }),
    TextColor,
    TextStyle,
    Underline,
    SimpliCityDocLink.configure(
        { openOnClick: false, autolink: false }
    ),
    SimpliCityImage,
    SimpliCityLink.configure(
        { openOnClick: false, autolink: false }
    ),
    SimpliCityParagraph,
    SimpliCityTable,
    TableCell,
    TableHeader,
    TableRow,
];

export { tiptapExtensions };
